import type { Card, DeckId } from '../../types';
import { apiJson } from './client';

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export async function getStatus() {
  return apiJson<{ ok: boolean; hasKey: boolean; model?: string; decks?: unknown }>('/api/status');
}

export async function sendChat(payload: {
  deckId: DeckId;
  card: Card;
  includeSummary: boolean;
  includeImage: boolean;
  model?: string;
  messages: ChatMessage[];
}) {
  return apiJson<{ reply: string; model: string; summaryUsed?: boolean; imageUsed?: boolean }>('/api/chat', {
    method: 'POST',
    body: JSON.stringify({
      deckId: payload.deckId,
      card: {
        id: payload.card.id,
        number: payload.card.number,
        chapter: payload.card.chapter,
        front: payload.card.front,
        back: payload.card.back,
      },
      figurePath: payload.card.figure,
      sourcePath: payload.card.source,
      includeSummary: payload.includeSummary,
      includeImage: payload.includeImage,
      model: payload.model,
      messages: payload.messages,
    }),
  });
}
